import { EventEmitter } from '@angular/core';

export interface ConfirmationDto {
  type?: 'danger' | 'warning';
  message: string;
  title?: string;
  acceptTitle?: string;
  rejectTitle?: string;
  acceptIconClass?: string;
  rejectIconClass?: string;
  accept?: any; // Function;
  reject?: any;
  acceptEvent?: EventEmitter<any>;
  rejectEvent?: EventEmitter<any>;
}

export interface StackTraceDto {
  methodName: string;
  fileName: string;
  lineNumber: number;
  className: string;
  nativeMethod: boolean;
}

export interface StackTraceExceptionDto {
  message: string;
  code: string;
  suggestion: string;
  httpStatus: string;
  exceptionMessage: string;
  stackTrace: StackTraceDto[];
}

export interface ToastData {
  timer?: number | boolean; // millisecond
  title?: string;
  message?: string;
  validationMessages?: string[];
  type?: ToastType;
  stackTrace?: StackTraceExceptionDto;
}

export enum ToastType {
  INFO = 'info',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  VALIDATIONS = 'validations'
}
